module.exports = __webpack_public_path__ + "img/live.f4184e7.svg";